export default function ClaimColonyIcon() {
	return (
		<svg id="claimColonyIcon" data-name="ClaimColony Icon" viewBox="0 0 32 32">
			<rect
				className="claimColonyBG"
				y="0"
				width="32"
				height="32"
				rx="4"
				ry="4"
			/>
			<path
				className="whiteFill"
				d="M22.58606,15.00696l-1.65078-1.60562-1.90667,1.8565,2.83994,2.76969c.39168.39211,1.02707.39247,1.41918.00079.00026-.00026.00053-.00053.00079-.00079l1.1992-1.16407h0l3.51229-3.41696-1.90667-1.85148-3.51229,3.41194h.00502Z"
			/>
			<path
				className="whiteFill"
				d="M20.52886,6.59252l-8.75564,8.68037c-.39766.38605-.40706,1.02137-.02102,1.41902.0069.00711.01391.01411.02102.02102h0l8.75564,8.69542c.4063.40041,1.05882.40041,1.46513,0l2.19769-2.17762-1.96688-1.95183-.96337.95334-6.28198-6.23181,6.28198-6.2318.91319.90316,1.96688-1.95183-2.14751-2.12744c-.4063-.40041-1.05882-.40041-1.46513,0Z"
			/>
			<path
				className="whiteFill"
				d="M13.04768,6.59252L4.3071,15.27289c-.39904.38462-.41073,1.0199-.02612,1.41894.00854.00886.01725.01757.02612.02612h0l8.74058,8.69041c.4063.40041,1.05882.40041,1.46513,0l2.19769-2.17762-1.9719-1.95183-.95835.95334-6.28198-6.23181,6.28198-6.2318.91319.90316,1.96688-1.95183-2.14751-2.12744c-.19258-.19654-.45743-.30538-.73256-.30105-.27426.0002-.53742.10835-.73256.30105Z"
			/>
		</svg>
	)
}
